(() => {
  const controllers = new Map();
  const mobile = window.matchMedia('(max-width: 740px)');

  function mount(slideshow) {
    if (controllers.has(slideshow)) return;
    const dots = slideshow.querySelector('page-dots[animation-timer]');
    const buttons = dots ? Array.from(dots.querySelectorAll('button')) : [];
    if (buttons.length < 2) return;

    let timer;
    let lastIndex = selectedIndex();
    let inView = true;
    let recoveryCount = 0;

    function selectedIndex() {
      return buttons.findIndex(button => button.getAttribute('aria-current') === 'true');
    }

    function interval() {
      const seconds = parseFloat(getComputedStyle(slideshow).getPropertyValue('--section-autoplay-duration'));
      return Number.isFinite(seconds) && seconds > 0 ? seconds * 1000 + 750 : 0;
    }

    function enabled() {
      return mobile.matches && document.visibilityState === 'visible' && inView &&
        slideshow.hasAttribute('auto-play') &&
        getComputedStyle(slideshow).getPropertyValue('--section-animation-play-state').trim() === 'running';
    }

    function reset() {
      clearTimeout(timer);
      if (!slideshow.isConnected) {
        destroy();
        return;
      }
      if (!enabled()) return;
      slideshow.querySelectorAll('.slideshow__image-wrapper.hidden-lap-and-up img[loading="lazy"]')
        .forEach(image => image.setAttribute('loading', 'eager'));
      const delay = interval();
      if (delay) timer = setTimeout(recover, delay);
    }

    function recover() {
      if (!slideshow.isConnected || !enabled()) {
        reset();
        return;
      }
      const index = selectedIndex();
      const bounds = slideshow.getBoundingClientRect();
      if (index < 0 || index !== lastIndex || slideshow.isTransitioning ||
          bounds.bottom <= 0 || bounds.top >= window.innerHeight) {
        lastIndex = index;
        reset();
        return;
      }
      dots.dispatchEvent(new CustomEvent('page-dots:changed', {
        bubbles: true,
        detail: { index: (index + 1) % buttons.length }
      }));
      recoveryCount += 1;
      slideshow.setAttribute('data-signal-slideshow-recoveries', String(recoveryCount));
      reset();
    }

    const selectionObserver = new MutationObserver(() => {
      const index = selectedIndex();
      if (index !== lastIndex) {
        lastIndex = index;
        reset();
      }
    });
    selectionObserver.observe(dots, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    const playerObserver = new MutationObserver(reset);
    playerObserver.observe(slideshow, { attributes: true, attributeFilter: ['style', 'auto-play'] });
    const visibilityObserver = window.IntersectionObserver ? new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      reset();
    }, { threshold: 0 }) : null;
    visibilityObserver?.observe(slideshow);
    document.addEventListener('visibilitychange', reset);
    mobile.addEventListener('change', reset);

    function destroy() {
      clearTimeout(timer);
      selectionObserver.disconnect();
      playerObserver.disconnect();
      visibilityObserver?.disconnect();
      document.removeEventListener('visibilitychange', reset);
      mobile.removeEventListener('change', reset);
      controllers.delete(slideshow);
    }

    controllers.set(slideshow, destroy);
    reset();
  }

  function initialize(root = document) {
    root.querySelectorAll('slide-show[auto-play]').forEach(mount);
  }

  customElements.whenDefined('slide-show').then(() => {
    initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('slide-show').forEach(slideshow => controllers.get(slideshow)?.());
    });
    window.addEventListener('pagehide', () => Array.from(controllers.values()).forEach(destroy => destroy()));
    window.addEventListener('pageshow', () => initialize());
  });
})();

